<template>
    <div class="panel-content">
        <div
            style="background-color: #F5F5F5; padding-left: 10px; padding-right: 10px; padding-bottom: 10px; padding-top: 10px;"
        >
            <div class="hotel-list listing-style3 hotel">
                <div class="hot-deals-list">
                    <div class="row hotel-list image-box hotel listing-style1 add-clearfix">
                        <div class="col-md-12">
                            <article
                                class="box"
                                v-bind:class="{ 'has-discount': getBookingCartIsSrvcAlreadyInCart({ id_pax: id_pax, srvcs: srvcs }) }"
                            >
                                <!-- >>> 'Added' Ribbon -->
                                <!-- >>> Detail:Header/Pic -->
                                <figure>
                                    <a class="hover-effect">
                                        <img width="200" height="50" alt v-bind:src="srvcs_image" />
                                        <span
                                            class="discount"
                                            v-show="getBookingCartIsSrvcAlreadyInCart({ id_pax: id_pax, srvcs: srvcs })"
                                        >
                                            <span
                                                class="discount-text"
                                            >{{ added[getCurrentLocale] }}</span>
                                        </span>
                                        <!-- >>> 'Added' Ribbon -->
                                    </a>
                                </figure>
                                <!-- <<< Detail:Header/Pic -->

                                <!-- >>> Detail:Header -->
                                <div class="details col-sm-12 col-md-12">
                                    <div>
                                        <div>
                                            <h4 class="box-title">
                                                {{ srvcs.description }}
                                                <small>
                                                    <i class="soap-icon-departure yellow-color"></i>
                                                    {{ srvcs.code }}
                                                </small>
                                            </h4>
                                            <!-- <div class="amenities">
                                                <i v-bind:class="soap_icon" style="color: #9e4d84;"></i>
                                            </div>-->
                                        </div>
                                        <div>
                                            <div class="amenities">
                                                <i v-bind:class="soap_icon" style="color: #9e4d84;"></i>
                                            </div>
                                            <!-- <div class="five-stars-container">
                                                <span class="five-stars" style="width: 100%;"></span>
                                            </div>
                                            <span class="review">111 {{ reviews[getCurrentLocale] }}</span>-->
                                        </div>
                                    </div>
                                    <div class="second-row">
                                        <div>
                                            <span v-if="srvcs.acceptComment === true && srvcs_type === 'PETS'">
                                                <br />
                                                <h4 class="box-title">{{ comment[getCurrentLocale] }}:</h4>
                                                <br />
                                                <div class="form-group row pet-comment-field">
                                                    <div class="col-md-10">
                                                        <label class="skin-color pet-comment-label">{{ petCommentBoxDimensions[getCurrentLocale] }}:</label>
                                                        <textarea
                                                            class="full-width"
                                                            rows="2"
                                                            ref="inputService_comment_boxDimensions"
                                                        ></textarea>
                                                        <span
                                                            class="pet-comment-error"
                                                            v-if="petCommentFieldErrors.boxDimensions"
                                                        >{{ commentfieldisemptytext[getCurrentLocale] }}</span>
                                                    </div>
                                                </div>
                                                <div class="form-group row pet-comment-field">
                                                    <div class="col-md-10">
                                                        <label class="skin-color pet-comment-label">{{ petCommentBoxWeight[getCurrentLocale] }}:</label>
                                                        <textarea
                                                            class="full-width"
                                                            rows="2"
                                                            ref="inputService_comment_boxWeight"
                                                        ></textarea>
                                                        <span
                                                            class="pet-comment-error"
                                                            v-if="petCommentFieldErrors.boxWeight"
                                                        >{{ commentfieldisemptytext[getCurrentLocale] }}</span>
                                                    </div>
                                                </div>
                                                <div class="form-group row pet-comment-field">
                                                    <div class="col-md-10">
                                                        <label class="skin-color pet-comment-label">{{ petCommentBreedAnimalType[getCurrentLocale] }}:</label>
                                                        <textarea
                                                            class="full-width"
                                                            rows="2"
                                                            ref="inputService_comment_breedAnimalType"
                                                        ></textarea>
                                                        <span
                                                            class="pet-comment-error"
                                                            v-if="petCommentFieldErrors.breedAnimalType"
                                                        >{{ commentfieldisemptytext[getCurrentLocale] }}</span>
                                                    </div>
                                                </div>
                                            </span>
                                            <span v-else-if="srvcs.acceptComment === true">
                                                <br />
                                                <h4
                                                    class="box-title"
                                                >{{ comment[getCurrentLocale] }}:</h4>
                                                <br />
                                                <div class="form-group row">
                                                    <div class="col-md-10">
                                                        <textarea
                                                            class="full-width"
                                                            rows="3"
                                                            ref="inputService_comment"
                                                        ></textarea>
                                                        <span
                                                            style="color: red;"
                                                            v-if="commentFieldIsEmpty"
                                                        >{{ commentfieldisemptytext[getCurrentLocale] }}</span>
                                                    </div>
                                                </div>
                                            </span>

                                            <br />
                                            <h4
                                                class="box-title"
                                                v-if="srvcs.remark !==''"
                                            >{{ remark[getCurrentLocale] }}:</h4>
                                            <br />
                                            <p v-html="srvcs.remark"></p>
                                            <!-- <p v-if="srvcs_type ==='MEAL'" style="margin-top:30px;">
                                                {{ meal_text2[getCurrentLocale] }}
                                                <a
                                                    href="https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf"
                                                    target="_blank"
                                                    style="font-size:15.9996px; color: #D6254D;"
                                                >{{ furtherservices_seat_here[getCurrentLocale] }}</a>.
                                            </p> -->
                                            <br />
                                            <br />
                                            <div class="col-md-4" style="padding-left: 0px;">
                                                <div class="icon">
                                                    <i class="soap-icon-plus yellow-color"></i>
                                                    <span
                                                        class="skin-color"
                                                    >{{ count[getCurrentLocale] }}:</span>
                                                    <br />
                                                </div>
                                                <div style="padding-top:4px;">
                                                    <!-- <span class="skin-color">Label</span><br> -->
                                                    <plusminsfield
                                                        :value="1"
                                                        :min="1"
                                                        :max="srvcs.maxBookablePax"
                                                        ref="userInputSrvcsDetails_Count"
                                                    ></plusminsfield>
                                                </div>
                                            </div>

                                            <div
                                                class="col-md-8 ipadKorrektur"
                                                style="padding-left: 0px;"
                                            >
                                                <div class="icon">
                                                    <i class="soap-icon-status yellow-color"></i>
                                                    <span
                                                        class="skin-color"
                                                    >{{ servicebookingfor[getCurrentLocale] }}:</span>
                                                    <br />
                                                </div>
                                                <div style="padding-top:4px;">
                                                    <toggle-button
                                                        :value="true"
                                                        ref="userInputSrvcsDetails_ToggleOut"
                                                        :labels="{ checked: outward[getCurrentLocale], unchecked: no[getCurrentLocale] }"
                                                        :color="{ checked: '#A2CB5A', unchecked: '#D9D9D8' }"
                                                        width="85"
                                                        height="30"
                                                        v-if="getDoesSrvcsExistOnOutOrRet('out', srvcs.code)"
                                                    />
                                                    <toggle-button
                                                        :value="false"
                                                        ref="userInputSrvcsDetails_ToggleOut"
                                                        :labels="{ checked: outward[getCurrentLocale], unchecked: no[getCurrentLocale] }"
                                                        :color="{ checked: '#A2CB5A', unchecked: '#D9D9D8' }"
                                                        width="85"
                                                        height="30"
                                                        disabled
                                                        v-if="!getDoesSrvcsExistOnOutOrRet('out', srvcs.code)"
                                                    />

                                                    <toggle-button
                                                        :value="true"
                                                        ref="userInputSrvcsDetails_ToggleRet"
                                                        :labels="{ checked: returnflight[getCurrentLocale], unchecked: no[getCurrentLocale] }"
                                                        :color="{ checked: '#A2CB5A', unchecked: '#D9D9D8' }"
                                                        width="85"
                                                        height="30"
                                                        v-if="getDoesSrvcsExistOnOutOrRet('ret', srvcs.code)"
                                                    />
                                                    <toggle-button
                                                        :value="false"
                                                        ref="userInputSrvcsDetails_ToggleRet"
                                                        :labels="{ checked: returnflight[getCurrentLocale], unchecked: no[getCurrentLocale] }"
                                                        :color="{ checked: '#A2CB5A', unchecked: '#D9D9D8' }"
                                                        width="85"
                                                        height="30"
                                                        disabled
                                                        v-if="!getDoesSrvcsExistOnOutOrRet('ret', srvcs.code)"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <span class="price">
                                                <small>a/{{ perleg[getCurrentLocale] }}</small>
                                                {{ srvcs.price | rndAmntRUAFWZ }}
                                            </span>
                                            <a
                                                class="button btn-small full-width text-center green"
                                                title
                                                @click.prevent="srvcsSelected({ id_pax: id_pax, srvcs: srvcs })"
                                            >{{ btn_addservices[getCurrentLocale] }}</a>
                                        </div>
                                    </div>
                                </div>
                                <!-- <<< Detail:Header -->
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PlusMinusField from '../../../shared/fields/PlusMinusField.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'plusminsfield': PlusMinusField

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: ['id_pax', 'srvcs', 'soap_icon', 'srvcs_image', 'srvcs_type', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                perleg: {
                    en: 'Leg',
                    de: 'Strecke',
                },
                remark: {
                    en: 'Remark',
                    de: 'Bemerkung',
                },
                btn_addservices: {
                    en: 'ADD SERVICE',
                    de: 'HINZUFÜGEN',
                },
                count: {
                    en: 'Number',
                    de: 'Anzahl',
                },
                servicebookingfor: {
                    en: 'Service booking for',
                    de: 'Service buchen für',
                },
                outward: {
                    en: 'Out',
                    de: 'Hin',
                },
                returnflight: {
                    en: 'Ret',
                    de: 'Rück',
                },
                no: {
                    en: 'No',
                    de: 'Nein',
                },
                alreadyincart: {
                    en: 'This service is already in your shopping cart.',
                    de: 'Dieser Service ist bereits in Ihrem Warenkorb.',
                },
                added: {
                    en: 'Added to Cart',
                    de: 'Hinzugefügt',
                },
                reviews: {
                    en: 'Reviews',
                    de: 'Reviews',
                },
                comment: {
                    en: 'Your Comment',
                    de: 'Ihr Kommentar'
                },
                commentfieldisemptytext : {
                    en: 'The comment field is a mandatory field:',
                    de: 'Das Kommentarfeld ist ein Pflichtfeld:'
                },
                petCommentBoxDimensions: {
                    en: 'Box Dimensions',
                    de: 'Abmessungen Box',
                },
                petCommentBoxWeight: {
                    en: 'Box Weight',
                    de: 'Gewicht Box',
                },
                petCommentBreedAnimalType: {
                    en: 'Breed Animal Type',
                    de: 'Tier-Rasse',
                },
                furtherservices_seat_here: {
                    en: 'here',
                    de: 'hier',
                },
                meal_text2: {
                    en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                    de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)',
                },
                // >>> --------------------------
                commentFieldIsEmpty: false,
                petCommentFieldErrors: {
                    boxDimensions: false,
                    boxWeight: false,
                    breedAnimalType: false,
                }
                // currentLocale: 'de',

            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getBookingLockfaresResults',
                // >>> --------------------------
                'getBookingCartIsSrvcAlreadyInCart',
                // >>> --------------------------
                'getServicesBookableServicesOutward',
                'getServicesBookableServicesReturn',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingUpdateCartWithSrvcs'
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * srvcsSelected()
            *
            * Desc: Service selected! Call ACTION!
            * Note: Check before Add! 'Passenger has already this Srvcs!'
            *
            *
            * @param {Object} srvcs (selected Srvcs)
            * @return {string}
            */
            srvcsSelected: function(srvcs) {

                var me = this;


                me.$toc('>>> booking/passengers/services/ServiceDetails.vue >>> srvcsSelected');
                // >>> Attach to Object ---------
                srvcs.srvcs.userInputSrvcsDetails_Count = this.$refs.userInputSrvcsDetails_Count.newValue;
                srvcs.srvcs.userInputSrvcsDetails_ToggleOut = this.$refs.userInputSrvcsDetails_ToggleOut.toggled;
                srvcs.srvcs.userInputSrvcsDetails_ToggleRet = this.$refs.userInputSrvcsDetails_ToggleRet.toggled;


                // >>> #338, CommentField is mandatory
                // >>> #810, PETS: 3 comment fields joined with \n for backend
                if (this.srvcs_type === 'PETS' && srvcs.srvcs.acceptComment === true) {
                    var boxDimensions = this.$refs.inputService_comment_boxDimensions.value.trim();
                    var boxWeight = this.$refs.inputService_comment_boxWeight.value.trim();
                    var breedAnimalType = this.$refs.inputService_comment_breedAnimalType.value.trim();

                    this.petCommentFieldErrors.boxDimensions = boxDimensions === '';
                    this.petCommentFieldErrors.boxWeight = boxWeight === '';
                    this.petCommentFieldErrors.breedAnimalType = breedAnimalType === '';

                    if (boxDimensions === '' || boxWeight === '' || breedAnimalType === '') {
                        this.commentFieldIsEmpty = true;
                    } else {
                        this.commentFieldIsEmpty = false;
                        this.petCommentFieldErrors.boxDimensions = false;
                        this.petCommentFieldErrors.boxWeight = false;
                        this.petCommentFieldErrors.breedAnimalType = false;
                        srvcs.srvcs.userInputSrvcsDetails_Comment = boxDimensions + '\n' + boxWeight + '\n' + breedAnimalType;
                    }
                } else if (this.$refs.inputService_comment !== undefined) {
                    if (this.$refs.inputService_comment.value === '') {
                        this.commentFieldIsEmpty = false; // 'let it go through', #66
                    } else {
                        this.commentFieldIsEmpty = false;
                        srvcs.srvcs.userInputSrvcsDetails_Comment = this.$refs.inputService_comment.value; // catch/save
                    }
                }


                // >>> Add to Cart --------------
                if (!this.getBookingCartIsSrvcAlreadyInCart(srvcs)) { // Already in Cart?
                    if (!this.commentFieldIsEmpty) {
                        this.actn_setBookingUpdateCartWithSrvcs(srvcs);
                    }
                } else {
                    me.$toasted.global.sdr_app_error({
                        message : this.alreadyincart[this.getCurrentLocale]
                    });
                }

            }, // eof srvcsSelected()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getDoesSrvcsExistOnOutOrRet()
            *
            * Desc: Check if a Srvcs exist on Flight Direction.
            * Note:
            *
            * @param {String} direction ('out', 'ret')
            * @param {String} code (Srvcs Code)
            * @return {Boolean}
            */
            getDoesSrvcsExistOnOutOrRet: function(direction, code) {

                var me = this,
                    srvcsExist = false;


                // me.$toc('>>> booking/passengers/services/ServiceDetails.vue >>> getDoesSrvcsExistOnOutOrRet');
                if (this.modulo === 'booking') {
                    if (direction === 'out') {
                        const result = this.getBookingLockfaresResults.outwardFlight.services.find(srvcs => String(srvcs.code) === String(code));
                        if (result !== undefined) {
                            srvcsExist = true;
                        }  else {
                            srvcsExist = false;
                        }
                    }

                    if (direction === 'ret') {
                        if (this.getBookingLockfaresResults.inboundFlight !== null) {
                            const result = this.getBookingLockfaresResults.inboundFlight.services.find(srvcs => String(srvcs.code) === String(code));
                            if (result !== undefined) {
                                srvcsExist = true;
                            }  else {
                                srvcsExist = false;
                            }
                        } else {
                                srvcsExist = false;
                        }

                    }
                }


                if (this.modulo === 'services') {
                    if (direction === 'out') {
                        const result = this.getServicesBookableServicesOutward.bookableServicesRS.services.find(srvcs => String(srvcs.code) === String(code));
                        if (result !== undefined) {
                            srvcsExist = true;
                        }  else {
                            srvcsExist = false;
                        }
                    }

                    if (direction === 'ret') {
                        if (this.getServicesBookableServicesReturn !== null) {
                            const result = this.getServicesBookableServicesReturn.bookableServicesRS.services.find(srvcs => String(srvcs.code) === String(code));
                            if (result !== undefined) {
                                srvcsExist = true;
                            }  else {
                                srvcsExist = false;
                            }
                        }
                    }
                }


                return srvcsExist;

            }, // eof getDoesSrvcsExistOnOutOrRet()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
a[target='_blank']:after {
    font-family: 'FontAwesome';
    content: ' \f08e';
}

.hotel-list {
    margin-top: 0px;
}
.box {
    margin-bottom: 0px;
}
.skin-color {
    text-transform: uppercase;
    font-size: 0.8333em;
}
.listing-style3.hotel .details > * > * {
    vertical-align: bottom;
    padding-bottom: 5px;
}
.listing-style3.hotel .details .button {
    margin-bottom: 5px;
}
.listing-style3 [class^='soap-icon'].circle:hover {
    color: #9e4d84;
}
.listing-style3 [class^='soap-icon'].circle.yellowchossen {
}

.listing-style3.hotel .details [class^='soap-icon'].circle {
    margin-top: 0px;
}

.vue-js-switch {
    font-size: 0.9167em;
}
.tab-container .tab-content .tab-pane .row {
    margin-bottom: 0px;
}

/* >>> SearchResult iPAD -------------------------------------------------*/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    h4 {
        font-size: 1.2em;
    }

    .price {
        font-size: 1.4em;
    }

    .ipadKorrektur {
        padding-left: 0px;
    }
}

.pet-comment-field {
    margin-bottom: 8px;
}

.pet-comment-label {
    display: block;
    margin-bottom: 3px;
    line-height: 1.2;
}

.pet-comment-field textarea {
    margin-top: 0;
    resize: vertical;
}

.pet-comment-error {
    color: red;
    display: block;
    margin-top: 5px;
}
</style>